import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import Image from 'next/image'
import type {Block} from '@/services/kontent-ai/types'
import {Button} from '@/products/flexible-web-toolkit/components/button/button'

export type CouponContentItem = IContentItem<{
	title: Elements.TextElement
	description: Elements.TextElement
	buttonText: Elements.TextElement
	footerText: Elements.TextElement
	logo: Elements.AssetsElement
	image: Elements.AssetsElement
	url: Elements.TextElement
	brandColor: Elements.MultipleChoiceElement
}>

export const CouponBlock: Block<CouponContentItem> = ({block}) => {
	const color = block.elements.brandColor[0]?.codename
	const buttonCTAcolor = color ? `bg-${color}` : 'bg-primary'
	const logoUrl = block.elements.logo[0]?.url
	const imageUrl = block.elements.image[0]?.url

	return (
		<div className="mx-auto mt-20 max-w-3xl rounded-lg border-2">
			<div className="flex flex-col px-4 py-6 md:flex-row md:px-12 md:py-10">
				<div className="w-full flex-col items-center pb-5 md:mr-6 md:w-1/3 md:p-0">
					{logoUrl ? (
						<div className="relative mx-auto h-16 w-1/2 pb-2.5 md:mx-0 md:w-full">
							<Image
								alt="coupon-logo"
								className="object-contain"
								fill
								sizes="(max-width: 768px) 50vw, 33vw"
								src={logoUrl}
							/>
						</div>
					) : null}
					{imageUrl ? (
						<div className="relative aspect-square w-full">
							<Image
								alt="coupon"
								className="object-cover"
								fill
								sizes="(max-width: 768px) 100vw, 33vw"
								src={imageUrl}
							/>
						</div>
					) : null}
				</div>
				<div className="w-full md:w-2/3">
					<h2 className="mb-5 text-2xl md:text-4xl">
						{block.elements.title}
					</h2>
					<p>{block.elements.description}</p>
					<Button
						className={`${buttonCTAcolor} mr-6 mt-6 w-full md:w-1/2`}
						href={block.elements.url}
						variant={buttonCTAcolor}
					>
						{block.elements.buttonText}
					</Button>
				</div>
			</div>
			<div className="flex bg-gray-300 px-12 py-5">
				<p className="text-xs text-gray-600">
					{block.elements.footerText}
				</p>
			</div>
		</div>
	)
}
